import React, { useContext } from 'react'
import styles from './ImageRow.module.scss';
import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css'

const ImageRow = (props) => {

	return (
		<div className={styles.container}>
			{props.contents.map((elem, index) => ((
				<div key={index}>
					<ImageAndPopup isHidden={true} image_src={elem.image_src} image_alt={elem.image_alt} title_message="Click anywhere to close popup" />
				</div>
			)))}
		</div>
	);
}

export const ImageRowForSlides = (props) => {
	const properties = {
		infinite: false,
		prevArrow: <div style={{ width: "30px", marginRight: "-30px", zIndex: "8" }}><svg width="24" height="24" viewBox="0 0 24 24"><path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z"></path></svg></div>,
		nextArrow: <div style={{ width: "30px", marginLeft: "-30px", zIndex: "8" }}><svg width="24" height="24" viewBox="0 0 24 24"><path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z"></path></svg></div>
	};
	//const properties = {
	//	prevArrow: <div style={{ width: "30px", marginRight: "-30px", cursor: "pointer" }}><img alt="left arrow" style={{ height: "30px", width: "30px" }} src="/preseedherbicide/images/chevron-left.png"></img></div>,
	//	nextArrow: <div style={{ width: "30px", marginLeft: "-30px", cursor: "pointer" }}><img alt="right arrow" style={{ height: "30px", width: "30px" }} src="/preseedherbicide/images/chevron-right.png"></img></div>,
	//	cssClass: "padding: 10px"
	//};

	return (
		<Slide {...properties} className={styles.slide_container}>
			{props.contents.map((elem, index) => ((
				elem.map((elem2, index) => ((
					<div className="each-slide" key={index}>
						<div style={{ 'backgroundImage': `url(${elem2.image_src})` }}>
						</div>
					</div>
				)))
			)))}
		</Slide>
	);
}

class ImageAndPopup extends React.Component {
	constructor(props) {
		super(props);
		this.state = { isHidden: props.isHidden, image_src: props.image_src, image_alt: props.image_alt, title_message: props.title_message };

		// This binding is necessary to make `this` work in the callback
		this.handleClickOpen = this.handleClickOpen.bind(this);
		this.handleClickClose = this.handleClickClose.bind(this);
		this.handleKeyOpen = this.handleKeyOpen.bind(this);
		this.handleKeyClose = this.handleKeyClose.bind(this);
	}

	handleClickOpen() {
		this.setState(prevState => ({
			isHidden: !prevState.isHidden
		}));
	}

	handleClickClose() {
		this.setState({
			isHidden: true
		});
	}
	handleKeyOpen(e) {
		if (e.keyCode === "32" || e.keyCode === "13")
			this.setState(prevState => ({
				isHidden: !prevState.isHidden
			}));

	}

	handleKeyClose(e) {
		if (e.keyCode === "32" || e.keyCode === "13")
			this.setState({
				isHidden: true
			});
	}

	render() {
		return (
			<div>

				<div
					className={styles.imageContainer}
					tabIndex="0"
					role="button"
					aria-pressed="false"

					onClick={this.handleClickOpen}
					onKeyDown={this.handleKeyOpen}
					data_tealium_category="page_banner"
					data_tealium_action="click"
					data_tealium_type="action"
					data_tealium_value={`${this.state.title_message}`}
				>
					<img
						src={this.state.image_src}
						alt={this.state.image_alt}
					/>

				</div>
				<div
					tabIndex="0"
					role="button"
					aria-pressed="false"
					onClick={this.handleClickClose}
					onKeyDown={this.handleKeyClose}

					data_tealium_category="page_banner"
					data_tealium_action="click"
					data_tealium_type="action"
					data_tealium_value={`${this.state.title_message}`}

					title={this.state.title_message} className={styles.pageMask}
					style={{ visibility: `${this.state.isHidden ? 'hidden' : 'visible'}` }}
				>
					<img
						src={this.state.image_src}
						alt={this.state.image_alt}
						className={styles.contentBox}
					/>
				</div >
			</div>
		);
	}
}


export default ImageRow;